module.exports = __webpack_public_path__ + "img/HongKongTrust7.66c2795d.png";